const API_URL = 'https://www.google.com/recaptcha/api.js?render=';
const SKIP_COUNTRIES = ['CN'];
const SKIP_TOKEN = 'skip_captcha';

export default {};
export { API_URL, SKIP_COUNTRIES, SKIP_TOKEN };
